/**
 * @ngInject
 */
/**
 *
 * we set configuration for angular solution. We set angular routes, so when you come to certain url, we define, which view to show..
 *
 * @param $routeProvider
 * @param fluxProvider
 * @param $authProvider
 * @param $mdThemingProvider
 * @param $mdDateLocaleProvider
 */
function config ($routeProvider, fluxProvider, $authProvider, $mdThemingProvider, $mdDateLocaleProvider) {

    // Angular Material settings
    moment.locale('da');

    $mdDateLocaleProvider.months = moment.months();
    $mdDateLocaleProvider.shortMonths = moment.monthsShort();
    $mdDateLocaleProvider.days = moment.weekdays();
    $mdDateLocaleProvider.shortDays = moment.weekdaysShort();

    $mdThemingProvider.definePalette('jobhajPurple', {
        '50': '453FD0',
        '100': '453FD0',
        '200': '453FD0',
        '300': '453FD0',
        '400': '453FD0',
        '500': '453FD0',
        '600': '453FD0',
        '700': '453FD0',
        '800': '453FD0',
        '900': '453FD0',
        'A100': '453FD0',
        'A200': '453FD0',
        'A400': '453FD0',
        'A700': '453FD0',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                    // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.definePalette('jobhajTurqoise', {
        '50': '29D3BA',
        '100': '29D3BA',
        '200': '29D3BA',
        '300': '29D3BA',
        '400': '29D3BA',
        '500': '29D3BA',
        '600': '29D3BA',
        '700': '29D3BA',
        '800': '29D3BA',
        '900': '29D3BA',
        'A100': '29D3BA',
        'A200': '29D3BA',
        'A400': '29D3BA',
        'A700': '29D3BA',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                    // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.definePalette('jobhajOrange', {
        '50': 'FF8C62',
        '100': 'FF8C62',
        '200': 'FF8C62',
        '300': 'FF8C62',
        '400': 'FF8C62',
        '500': 'FF8C62',
        '600': 'FF8C62',
        '700': 'FF8C62',
        '800': 'FF8C62',
        '900': 'FF8C62',
        'A100': 'FF8C62',
        'A200': 'FF8C62',
        'A400': 'FF8C62',
        'A700': 'FF8C62',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                    // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    // Palette adjustment
    $mdThemingProvider.theme('default')
        .primaryPalette('jobhajPurple')
        .accentPalette('jobhajTurqoise')
        .warnPalette('jobhajTurqoise');

    $mdDateLocaleProvider.firstDayOfWeek = 1;

    // Format date 
    $mdDateLocaleProvider.formatDate = function(date) {
        if(date !== undefined){
            return moment(date).locale('da').format('L');
        } else {
            return "";
        }
    };

    fluxProvider.setImmutableDefaults({ immutable: false });

    // Auth config
    // $authProvider provided by satellizer
    $authProvider.loginUrl = '/api/authenticate';
    $authProvider.signupUrl = '/api/signup';
    $authProvider.facebook({
        clientId: window.facebook_client_id,
        url: '/api/authenticate_callback',
        redirectUri: window.location.origin + '/',
    });

    $routeProvider
        .when('/login', {
            templateUrl: '../angular/views/jobhaj-login.html',
        })
        // default login
        .when('/', {
            templateUrl: '../angular/views/jobhaj-application.html',
            controller: HomeCtrl,
            controllerAs: '$ctrl'
        })
        .when('/billede', {
            templateUrl: '../angular/views/application-image.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/info', {
            templateUrl: '../angular/views/application-info.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/personlighed', {
            templateUrl: '../angular/views/application-personality.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/motivation', {
            templateUrl: '../angular/views/application-motivation.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/interesser', {
            templateUrl: '../angular/views/application-interests.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/erfaring', {
            templateUrl: '../angular/views/application-experience.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/sprog', {
            templateUrl: '../angular/views/application-languages.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/arbejdstimer', {
            templateUrl: '../angular/views/application-workhours.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .when('/udseende', {
            templateUrl: '../angular/views/application-look.html',
            controller: DetailCtrl,
            controllerAs: '$ctrl'
        })
        .otherwise({redirectTo:'/'});

    /**
     *  these two controllers only responsible for setting pageClass varible.. Look into each view for each route to see,
     *  which controller is called..
     */
    function HomeCtrl($timeout, $animate){
        var ctrl = this;
        
        $timeout(function(){
            $animate.enabled(true);
        });
        ctrl.pageClass = 'home';
    }

    function DetailCtrl($timeout, $animate){
        var ctrl = this;

        $timeout(function(){
            $animate.enabled(true);
        });
        ctrl.pageClass = 'detail';
    }

}